// extracted by mini-css-extract-plugin
export var addressFields = "_ml-0";
export var animationContainer = "_ml-1";
export var footer = "_ml-2";
export var lineItems = "_ml-3";
export var modalContent = "_ml-4";
export var orderName = "_ml-5";
export var strong = "_ml-6";
export var warning = "_ml-7";